import type { ComponentPropsWithRef, ReactNode } from 'react'
import { Image } from '@/React/Shared/Component/Image'

export interface BaseMockBookingFormContainerProps extends Omit<
    ComponentPropsWithRef<'div'>,
    'content'
> {
    children?: ReactNode
}

function BaseMockBookingFormContainer({
    children,
    className = '',
    ...restProps
}: BaseMockBookingFormContainerProps) {
    return (
        <div
            {...restProps}
            className={`relative ${className}`.trim()}
        >
            <div className="rounded-xl border border-slate-200 bg-white p-3 shadow-xs shadow-slate-200/70 lg:mx-0 lg:ml-auto space-y-2">
                <div className="flex items-center justify-between px-1">
                    <div className="flex items-center gap-2">
                        <span className="h-3 w-3 rounded-full bg-red-400"></span>
                        <span className="h-3 w-3 rounded-full bg-amber-400"></span>
                        <span className="h-3 w-3 rounded-full bg-emerald-400"></span>
                    </div>
                </div>

                {children}
            </div>
        </div>
    )
}

function BaseMockBookingFormAddressBar({
    children,
    className = '',
    ...restProps
}: ComponentPropsWithRef<'div'>) {
    return (
        <div
            {...restProps}
            className={className}
        >
            {children}
        </div>
    )
}

interface BaseMockBookingFormContentProps extends ComponentPropsWithRef<'div'> {
    coverImageUrl?: string | null
}

function BaseMockBookingFormContent({
    coverImageUrl,
    children,
    className = '',
    ...restProps
}: BaseMockBookingFormContentProps) {
    return (
        <div
            {...restProps}
            className={`overflow-hidden rounded-xl border border-slate-200 ${className}`.trim()}
        >
            <Image
                src={
                    coverImageUrl ?? '/static/images/booking-form/default.webp'
                }
                alt="Booking form cover"
                className="h-28 w-full object-cover"
            />
            {children}
        </div>
    )
}

export const BaseMockBookingForm = Object.assign(BaseMockBookingFormContainer, {
    Container: BaseMockBookingFormContainer,
    AddressBar: BaseMockBookingFormAddressBar,
    Content: BaseMockBookingFormContent,
})
